"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getHtmlAttributes;
var parser = new DOMParser();

function getHtmlAttributes(attributes) {
  if (attributes) {
    var htmlResult = parser.parseFromString("<div " + attributes + " />", "text/html");
    var tempEl = htmlResult.body.firstChild;
    return Object.fromEntries(Object.values(tempEl.attributes).map(function (attr) {
      return [attr.name, attr.value];
    }));
  }
  return {};
}